import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import RoomHero from '../components/RoomHero';
import RoomOverview from '../components/RoomOverview';
import RoomGallery from '../components/RoomGallery';
import OtherServices from '../components/OtherServices';
import images1 from '../assets/images/Standard_1.jpg';
import images2 from '../assets/images/delux_2.jpg';
import images3 from '../assets/images/accomedation_2.jpg';
import images4 from '../assets/images/delux_1.jpg';
import images6 from '../assets/images/accomedation_8.jpg';

const RoomDeluxe = ({ language }) => {
  const title = { en: 'Deluxe Room', am: 'ዴሉክስ ክፍል' };
  const subtitle = { en: 'Elegance and space for a premium stay', am: 'ለከፍተኛ ጥራት መኖሪያ ምቹ እና ውብ' };
  const heroImage = images1;

  const overview = {
    en: 'Our Deluxe Rooms offer generous space with premium bedding, a comfortable work desk, and large windows with city or garden views. Perfect for business travelers or couples seeking an elevated experience.',
    am: 'ዴሉክስ ክፍሎቻችን ሰፊ ቦታ፣ ጥራታማ መኝታ እቃ፣ ምቹ የስራ ዴስክ እና የከተማ ወይም የአበባ እይታ ያላቸው መስኮቶችን ያቀርባሉ። ለንግድ ተጓዦች ወይም ለጥራት የሚመኙ ሰዎች ተስማሚ ናቸው።'
  };

  const highlights = [
    { en: 'Premium king or queen bedding', am: 'ጥራታማ የኪንግ ወይም ኩዊን አልጋ' },
    { en: 'Dedicated work desk and chair', am: 'ልዩ የስራ ጠረጴዛ እና ወንበር' },
    { en: 'Smart TV and fast Wi‑Fi', am: 'ስማርት ቲቪ እና ፈጣን ዋይ-ፋይ' },
    { en: 'In-room tea/coffee and minibar', am: 'በክፍል ውስጥ ቲ/ቡና እና ሚኒ ባር' },
    { en: 'Accommodation includes breakfast and hotel amenities', am: 'መመዝገቢያው ቁርስን እና የሆቴሉን አመናካኝ አገልግሎቶችን ያካትታል' }
  ];

  const galleryTitle = { en: 'Deluxe Room Gallery', am: 'የዴሉክስ ክፍል ጋለሪ' };
  const images = [images1, images2, images3, images4, images6];

  return (
    <>
      <SEO
        title="Deluxe Room"
        description="Experience luxury in our Deluxe Rooms at Blue Nest Hotel. Spacious, elegant, and perfect for a premium stay."
        url="/rooms/deluxe"
      />
      <RoomHero title={title} subtitle={subtitle} image={heroImage} language={language} />
      <RoomOverview language={language} overview={overview} highlights={highlights} />
      <div className="container my-4 text-center">
        <Link to="/contact" className="text-decoration-none">
          <button className="room-cta-btn">
            {language === 'am' ? 'ይዘዙ ክፍል' : 'Reserve this Room'}
          </button>
        </Link>
      </div>
      <RoomGallery language={language} title={galleryTitle} images={images} />
      <OtherServices language={language} />
    </>
  );
};

export default RoomDeluxe;
